import GoodsTracking from "@/pages/bmw/GoodsTracking"
import GoodsTrackingMap from "@/pages/bmw/GoodsTrackingMap"
import Index from "@/pages/bmw/Index"
import Search from "@/pages/bmw/Search"
import Th from "@/pages/bmw/th/Index"
import ThOrder from "@/pages/bmw/th/Order"
import ThGoods from "@/pages/bmw/th/Goods"
import ThTrans from "@/pages/bmw/th/Trans"
import ThFiles from "@/pages/bmw/th/Files"
import Sh from "@/pages/bmw/sh/Index"
import ShOrder from "@/pages/bmw/sh/Order"
import ShGoods from "@/pages/bmw/sh/Goods"
import ShTrans from "@/pages/bmw/sh/Trans"
import ShFiles from "@/pages/bmw/sh/Files"
import Thd from "@/pages/bmw/Thd"
import Psd from "@/pages/bmw/Psd"
import Abnormal from "@/pages/bmw/Abnormal"

let router = [{
    path: "/bmw/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/bmw/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/bmw/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/bmw/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/bmw/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  }, {
    path: "/bmw/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/bmw/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/bmw/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/bmw/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/bmw/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/bmw/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/bmw/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/bmw/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/bmw/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/bmw/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/bmw/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  },{
    path: "/bmw/transfer",
    name: "transfer",
    component: () => import('@/pages/bmw/Transfer'),
    meta: {
      title: "中转",
      keepAlive: false,
      login: false
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/bmw.js